import { useCallback, useState } from "react";
import { toast } from "sonner";
import api from "./api";

/**
 * useAutoSavePatch — kleiner Hook für Auto-Save (onBlur/onChange) per PATCH.
 * Ersetzt explizite „Speichern"-Buttons. Liefert `save(partial, opts)` sowie
 * `saving`/`savedAt` für die „Gespeichert ✓"-Statusanzeige.
 *
 * opts.undo = { patch, apply } → zeigt einen „Rückgängig"-Toast: bei Klick wird
 * `patch` (die vorherigen Werte) erneut gespeichert und `apply()` setzt den
 * lokalen Formularzustand zurück.
 */
export function useAutoSavePatch(endpoint) {
    const [saving, setSaving] = useState(false);
    const [savedAt, setSavedAt] = useState(0);

    const save = useCallback(async (partial, opts = {}) => {
        setSaving(true);
        try {
            await api.patch(endpoint, partial);
            setSavedAt(Date.now());
            if (opts.undo) {
                toast.success("Gespeichert", {
                    description: opts.undo.label || undefined,
                    action: {
                        label: "Rückgängig",
                        onClick: async () => {
                            try {
                                await api.patch(endpoint, opts.undo.patch);
                                opts.undo.apply?.();
                                toast.success("Rückgängig gemacht");
                            } catch (e) {
                                toast.error(e.response?.data?.detail || "Rückgängig fehlgeschlagen");
                            }
                        },
                    },
                });
            }
            return true;
        } catch (e) {
            toast.error(e.response?.data?.detail || "Speichern fehlgeschlagen");
            return false;
        } finally {
            setSaving(false);
        }
    }, [endpoint]);

    return { save, saving, savedAt };
}
